import { styled, Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import TableCellComponent from "components/table/TableCellComponent";
import TableRowComponent from "components/table/TableRowComponent";
import { HEADER_COMPANY_TABLE } from "constants/data";
import ButtonComponent from "components/button/ButtonComponent";
import generateUniqueId from "util/generate_id";
import { CompanyType } from "../types/company";

interface CompanyTableProps {
  companies: CompanyType[];
  selectCompany: (company: CompanyType) => void;
}

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(even)": {
    backgroundColor: "var(--offwhite-300)",
  },
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--white)",
  },
}));

/**
 * CompanyTable component renders a table with company details.
 *
 * @param {CompanyTableProps} props - The properties for the component.
 * @param {Company[]} props.companies - The list of companies to display.
 * @returns {JSX.Element} The rendered table component.
 */
export default function CompanyTable({ companies, selectCompany }: CompanyTableProps) {
  return (
    <TableContainer
      component={Table}
      sx={{
        width: "100%",
        minWidth: 700,
        boxShadow: "none",
      }}
    >
      <TableHead>
        <TableRowComponent data={HEADER_COMPANY_TABLE} type="header" />
      </TableHead>
      <TableBody>
        {companies.map((company, index) => (
          <StyledTableRow
            key={generateUniqueId(index)}
            className={index % 2 === 0 ? "even" : "odd"}
          >
            <TableCellComponent>{company.company_cd}</TableCellComponent>
            <TableCellComponent sx={{ textAlign: "left" }}>
              {company.company_name}
            </TableCellComponent>
            <TableCellComponent sx={{ textAlign: "center" }}>
              <ButtonComponent
                onClick={() => selectCompany(company)}
                sx={{
                  color: "var(--black)",
                  fontSize: { xs: 14, md: 16 },
                  borderRadius: "4px",
                  width: "160px",
                  height: "40px",
                  whiteSpace: "nowrap",
                }}
                label="店舗得意先一覧"
              />
            </TableCellComponent>
          </StyledTableRow>
        ))}
      </TableBody>
    </TableContainer>
  );
}
